import type { MultipleQueriesQuery } from '@algolia/client-search';

import {
  CANDIDATE_INDEX_EXTENSION,
  RuleContexts,
} from '@/domains/productDiscovery/algolia/constants';
import { getDefaultIndex } from '@/domains/productDiscovery/algolia/settings/settings.common';
import { DEFAULT_ATTRIBUTES_TO_RETRIEVE } from '@/domains/productDiscovery/HeaderLeonidas/modules/productSuggestions/services/algolia/constants';
import { SponsoredProduct } from '@/productDiscovery/Listings/sponsoredProducts/interfaces/sponsoredProduct';

import { MAX_HITS_PER_PAGE } from '../../constants';

export const buildSuggestionsProductsSearchParameters = (
  query: string,
  options: {
    rerankingAbTest?: boolean;
    ranking?: boolean;
    reranking?: boolean;
    sponsoredProducts: SponsoredProduct[];
  },
): MultipleQueriesQuery[] => {
  const { reranking, rerankingAbTest, ranking, sponsoredProducts } = options;
  const ruleContexts = [];
  let indexName = getDefaultIndex().value;

  if (reranking) {
    ruleContexts?.push(
      `${
        rerankingAbTest
          ? RuleContexts.RERANKING_SEARCH_ALTERNATE
          : RuleContexts.RERANKING_SEARCH
      }`,
    );
  }

  if (ranking) {
    indexName = `${indexName}${CANDIDATE_INDEX_EXTENSION}`;
  }

  const isQueryIncludesSponsoredProducts =
    sponsoredProducts && sponsoredProducts.length > 0;
  return isQueryIncludesSponsoredProducts
    ? [
        {
          indexName,
          query,
          params: {
            hitsPerPage: MAX_HITS_PER_PAGE,
            clickAnalytics: true,
            facetingAfterDistinct: true,
            analytics: true,
            attributesToRetrieve: DEFAULT_ATTRIBUTES_TO_RETRIEVE,
            attributesToHighlight: [],
            responseFields: ['hits', 'index', 'nbHits'],
            ruleContexts,
            filters: `${sponsoredProducts
              .map((sp) => `NOT objectID:${sp.productId}`)
              .join(' AND ')}`,
          },
        },
        {
          indexName,
          query,
          params: {
            attributesToRetrieve: DEFAULT_ATTRIBUTES_TO_RETRIEVE,
            attributesToHighlight: [],
            responseFields: ['hits', 'index'],
            filters: `${sponsoredProducts
              .map((sp) => `objectID:${sp.productId}`)
              .join(' OR ')}`,
          },
        },
      ]
    : [
        {
          indexName,
          query,
          params: {
            hitsPerPage: MAX_HITS_PER_PAGE,
            clickAnalytics: true,
            facetingAfterDistinct: true,
            analytics: true,
            attributesToRetrieve: DEFAULT_ATTRIBUTES_TO_RETRIEVE,
            attributesToHighlight: [],
            responseFields: ['hits', 'index', 'nbHits'],
            ruleContexts,
          },
        },
      ];
};
